import { Button, Typography } from '@capsule/consumer-design-system';

import styled from 'styled-components';
import InlineSVG from 'svg-inline-react';

export const AppDownloadPageContainer = styled.div`
  padding: 20px 20px 0 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: ${props => props.theme.colors.capsuleBlue50};
`;

export const CloseIconContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: end;
  width: 100%;
`;

export const AppDownloadIcon = styled(InlineSVG)`
  width: 10rem;
  padding-top: 2rem;
  padding-bottom: 2rem;
  svg {
    width: 10rem;
    height: 10rem;
  }
`;

export const BenefitList = styled.ul`
  list-style-type: none; /* Remove bullet points */
  padding-top: 2rem;
`;

export const BenefitListItem = styled.li`
  margin-bottom: 1rem; /* Add margin to create space between each row */
`;

export const OpenCapusleAppButton = styled(Button)`
  width: 100%;
  margin-bottom: 1.5rem;
  height: 50px;
`;

export const StayOnWebButton = styled(Button)`
  height: 50px;
`;

export const BenefitsTitle = styled(Typography)`
  text-align: center;
`;

export const ButtonGrouping = styled.div`
  position: absolute;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding: 0rem 2rem 0rem 2rem;
  bottom: 0rem;
  height: 110px;
  max-height: 110px;
`;

export const BenefitsContainer = styled.div`
  width: 100%;
  flex-grow: 1;
  max-height: calc(100vh - 220px);
  overflow: auto;
  align-items: center;
  display: flex;
  flex-direction: column;
`;

export const OpaqueBlock = styled.div`
  display: block;
  width: 100%;
  height: 30px;
  background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0), rgba(255, 255, 255, 1));
  top: -30px;
  position: absolute;
`;
